import { ThemeOptions } from '@mui/material';

export const typographyThemeOptions: ThemeOptions = {
  typography: {
    fontFamily: 'Public Sans',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightBold: 700,
    allVariants: {
      fontFamily: 'Public Sans',
      textAlign: 'left',
    },
    body1: { fontWeight: 400 },
    body2: { fontWeight: 400 },
    subtitle1: { fontWeight: 600 },
    subtitle2: { fontWeight: 500 },
    caption: { fontWeight: 400 },
    overline: { fontWeight: 400 },
    h1: { fontWeight: 500 },
    h2: { fontWeight: 500 },
    h3: { fontWeight: 500 },
    h4: { fontWeight: 500 },
    h5: { fontWeight: 500 },
    h6: { fontWeight: 400 },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        body {
          font-family: 'Public Sans', sans-serif;
        }
      `,
    },
  },
};
